export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '暖暖爱视频需要注册才能观看吗？',
    answer: '完全不需要！暖暖爱视频致力于为用户提供最便捷的观看体验，无需注册、无需登录，打开网站即可免费观看所有高清视频内容。',
  },
  {
    question: '暖暖爱视频支持哪些设备观看？',
    answer: '暖暖爱视频全面支持手机、平板、电脑等多种设备观看。无论你使用iOS、Android还是Windows设备，都可以获得流畅的高清观看体验。',
  },
  {
    question: '视频画质怎么样？能否观看高清内容？',
    answer: '暖暖爱视频所有内容均提供高清画质，最高支持1080P清晰度。我们采用先进的视频编码技术，在保证画质的同时确保流畅播放，让你享受如影院般的观影体验。',
  },
  {
    question: '暖暖爱视频的内容会定期更新吗？',
    answer: '会的！我们每天都会更新最新的视频内容，确保你能第一时间观看到暖暖爱的最新剧集和精彩内容。关注我们的更新频道，不错过任何精彩。',
  },
  {
    question: '观看视频需要下载专门的播放器吗？',
    answer: '不需要下载任何软件或插件。暖暖爱视频采用先进的网页播放技术，直接在浏览器中就能流畅观看，省去了繁琐的安装步骤。',
  },
  {
    question: '暖暖爱视频是否收费？',
    answer: '暖暖爱视频始终坚持免费服务，所有视频内容均可免费观看，无需支付任何费用。我们承诺为用户提供永久免费的高质量视频服务。',
  },
  {
    question: '观看过程中出现卡顿怎么办？',
    answer: '如果遇到卡顿情况，建议检查网络连接状态，或者尝试降低视频清晰度。也可以关闭其他占用带宽的应用程序，或更换网络环境后重新尝试。',
  },
];